import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import CircularProgress from "@mui/material/CircularProgress";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import curved9 from "assets/images/curved-images/curved9.jpg";
import { useTranslation } from "react-i18next";
import { Visibility, VisibilityOff } from "@mui/icons-material"; // Import icons
import { Box, IconButton } from "@mui/material";
import { useAuth } from "context/auth-context/auth.context";
import AuthApi from "api/auth";
import NotificationService from "utils/notificationService";

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const [formData, setFormData] = useState({ phone: "", password: "" });
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState("");

  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State for password visibility
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const token = localStorage.getItem("token");
  const { t } = useTranslation();

  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    AuthApi.Login(formData)
      .then((response) => {
        setLoading(false);
        if (response.data.msg === "Login Success") {
          setProfile(response);
          const role = response?.data?.business_role_id;
          role === "warehouse_owner" || role === "admin"
            ? navigate("/statistiques/statistiques-generales")
            : navigate("/gestion-des-commandes/commandes-encours");
        } else {
          setError(response.data.msg);
        }
      })
      .catch((error) => {
        setLoading(false);
        setError(
          error.response ? error.response.data.msg : "There has been an error."
        );
      });
  };

  const setProfile = (response) => {
    const user = { ...response.data.username, token: response.data.access };
    setUser(user);
    localStorage.setItem("user", JSON.stringify(response.data));
    localStorage.setItem("token", response.data.access);
    localStorage.setItem("manager", response.data.username);

    // Automatically initialize notifications after login
    if (NotificationService.isSupported()) {
      NotificationService.init(response.data.access);
    }
    // Check if the role is 'client' or 'delivery_man' and redirect them if so
    const role = response?.data?.business_role_id; // Assuming role is in response.data.role
    if (role === "client" || role === "delivery_man") {
      localStorage.removeItem("user");
      localStorage.removeItem("token");

      //     // Redirect unauthorized users
      //     navigate("/authentication/error/unauthorized"); // Redirect to an unauthorized page
      //     return; // Exit early
      //   }

      role === "warehouse_owner" || role === "admin"
        ? navigate("/statistiques/statistiques-generales")
        : navigate("/gestion-des-commandes/commandes-encours");
    }
  };

  return (
    <>
      <BasicLayout title={t("Welcome to")} image={curved9}>
        {!token ? (
          <Card>
            <SoftBox p={3} mb={1} textAlign="center">
              <SoftTypography variant="h5" fontWeight="medium">
                {t("login")}
              </SoftTypography>
            </SoftBox>
            <SoftBox textAlign="center">
              <SoftTypography
                variant="button"
                color="text"
                fontWeight="regular"
              >
                ({t("phone and password")})
              </SoftTypography>
            </SoftBox>
            <SoftBox p={3}>
              <SoftBox component="form" role="form" onSubmit={handleSubmit}>
                <SoftBox mb={2}>
                  <SoftInput
                    type="text"
                    placeholder="Téléphone"
                    value={formData.phone}
                    name="phone"
                    onChange={handleChange}
                  />
                </SoftBox>
                <SoftBox mb={2}>
                  <Box sx={{ position: "relative" }}>
                    <SoftInput
                      type={showPassword ? "text" : "password"}
                      placeholder="Mot de passe"
                      value={formData.password}
                      name="password"
                      onChange={handleChange}
                    />
                    <IconButton
                      onClick={togglePasswordVisibility}
                      sx={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </Box>
                </SoftBox>
                <SoftBox display="flex" alignItems="center">
                  <Switch checked={rememberMe} onChange={handleSetRememberMe} />
                  <SoftTypography
                    variant="button"
                    fontWeight="regular"
                    onClick={handleSetRememberMe}
                    sx={{ cursor: "pointer", userSelect: "none" }}
                  >
                    &nbsp;&nbsp;{t("Remember me")}
                  </SoftTypography>
                </SoftBox>
                <SoftBox mt={2} mb={2} textAlign="center">
                  <h6
                    style={{
                      fontSize: ".8em",
                      color: "red",
                      textAlign: "center",
                      fontWeight: 400,
                    }}
                  >
                    {error}
                  </h6>
                </SoftBox>
                <SoftBox mt={4} mb={1}>
                  <SoftButton
                    variant="gradient"
                    color="info"
                    fullWidth
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      t("login")
                    )}
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </Card>
        ) : null}
      </BasicLayout>
    </>
  );
}

export default Basic;
